import { Injectable } from '@angular/core';
import {
  GeocoderOptions,
  geocoderPluck,
  GeocoderPluckMap
} from '@element451-libs/utils451/google-maps';
import { google } from 'google-maps';
import { filter } from 'lodash';

export interface PlaceComponents {
  location?: google.maps.LatLngLiteral;
  state?: google.maps.GeocoderAddressComponent | string;
  province?: google.maps.GeocoderAddressComponent | string;
  country?: google.maps.GeocoderAddressComponent | string;
  city?: google.maps.GeocoderAddressComponent | string;
  street1?: string;
  formatted_address: string;
  zipcode?: string;
}

@Injectable()
export class GoogleAutocompleteService {
  buildDataFromPlace(
    place: google.maps.places.PlaceResult,
    options: GeocoderOptions
  ): PlaceComponents {
    if (!place.address_components) {
      return;
    }

    const street1 = filter(
      place.address_components,
      c =>
        c.long_name !== 'undefined' &&
        (c.types.indexOf('route') > -1 || c.types.indexOf('street_number') > -1)
    ).reduce(
      (street, c) =>
        street.length !== 0 ? `${street} ${c.long_name}` : c.long_name,
      ''
    );

    const countryComponent = place.address_components.find(component =>
      component.types.includes('country')
    );

    const components = geocoderPluck(options, place.address_components);

    const location = place.geometry.location.toJSON();
    const formatted_address = place.formatted_address;

    const transformedComponents = transformComponents(
      components,
      countryComponent
    );

    return {
      ...transformedComponents,
      location,
      street1,
      formatted_address
    };
  }
}

export const isNonUSCountry = (
  country: google.maps.GeocoderAddressComponent
) => {
  return country.short_name !== 'US';
};

/**
 * Transforms the components object to map state to province if the country is not the US
 * @param components - The components object to transform
 * @param countryComponent - The country component to check
 * @returns The transformed components object
 */
export const transformComponents = (
  components: GeocoderPluckMap,
  countryComponent: google.maps.GeocoderAddressComponent
) => {
  const transformedComponents = { ...components };
  if (isNonUSCountry(countryComponent) && components.state) {
    transformedComponents.province = components.state;
    transformedComponents.state = null;
  }
  return transformedComponents;
};
